import React, {useContext, useEffect, useLayoutEffect, useState} from "react";
import {isFullSwing, ITEM_WEIGHT, LANDING_PAGE_URL, SESSION_EXPIRE_TIME} from "../constants";
import FSHeader from "../components/FSHeader";
import Div from "../lib/Div";
import FontAwesome from "@expo/vector-icons/FontAwesome";
import P from "../lib/P";
import NewHeader from "../components/NewHeader";
import {StoreContext} from "../components/StoreContextProvider";
import useIdleLogout from "../hooks/useIdleLogout";
import AsyncStorage from "@react-native-async-storage/async-storage";
import moment from "moment";
import {ActivityIndicator, Image, Platform, ScrollView} from "react-native";
import {LevelTournamentList, User} from "../../generated/smg_service_pb";
import {colors} from "../assets/styles/colors";
import {useIsFocused, useNavigation} from "@react-navigation/native";
import {NativeStackNavigationProp} from "@react-navigation/native-stack";
import ServiceClient from "../utils/ServiceClient";
import {tournamentShotsBeforeEntry} from "../utils";
import {CancelModalProps} from "../types";
import MainStyle from "../../MainStyle";
import star from "../assets/img/icons/star.svg";
import series_circle from "../assets/img/series_circle.svg";
import Btn from "../components/Btn";

const SatelliteTournaments = () => {
  const Context = useContext(StoreContext);
  const {user, cancelModalConfig, session, extendedUserData} = Context;
  const [isLoading, setIsLoading] = useState(false);
  const isFocused = useIsFocused();
  const navigation: NativeStackNavigationProp<any> = useNavigation();
  const [levelsList, setLevelsList] = useState<LevelTournamentList[]>([]);
  const restrictEntry = tournamentShotsBeforeEntry(extendedUserData);
  const activeColor = isFullSwing ? '#3369FF' : restrictEntry > 0 ? colors.gray : colors.newGreenText;

  const goTo = (level: number) => () => {
    navigation.navigate({name: 'LevelSatellites', params: {level}});
  };

  const getTournamentSchedule = () => {
    ServiceClient.getTournamentSchedule().then(res => {
      const val = res.sort((a, b) => {
        if (a.level > b.level) return -1;
        if (a.level < b.level) return 1;
        return 0;
      });

      console.log('getTournamentSchedule res', val);
      setLevelsList(val);
      Context.setLoadingOverlay(false);
      setIsLoading(false);

    }).catch(err => {
      console.log('getTournamentSchedule err', err);
      Context.setLoadingOverlay(false);
      setIsLoading(false);

      let conf: CancelModalProps = {
        visible: true, title: 'ERROR', leftBtnText: 'OK', subtitle: err.message,
        onExit: () => {
          Context.setCancelModalConfig({...cancelModalConfig, visible: false});
        }
      };

      Context.setCancelModalConfig(conf);
    });
  };

  const getUser = () => {
    Context.getUser().catch(err => {
      console.log('getUser err', err);
      setTimeout(() => {
        getUser();
      }, 5000);
    });
  };

  useEffect(() => {
    if (!user || !isFocused) return;

    getTournamentSchedule();

    const time = setTimeout(() => {
      getUser();
    }, 1000 * 10);

    return () => {
      clearTimeout(time);
    };
  }, [user, isFocused]);

  useIdleLogout({enabled: isFocused, onLogout: () => setIsLoading(false)});

  useLayoutEffect(() => {
    setIsLoading(true);

    if (!session || !user) {
      (async () => {
        const time = await AsyncStorage.getItem('lastActiveTime');

        if (time && moment().diff(moment(time), 'minutes') > SESSION_EXPIRE_TIME) {
          Context.logout().then(() => {
            if (Platform.OS === 'web') window.open(LANDING_PAGE_URL, '_self');
          });

        } else {
          const val = await AsyncStorage.getItem('session');
          let curUser: User | undefined;

          if (val) {
            const Session = JSON.parse(val);
            Context.setSession(Session);

            try {
              curUser = await Context.getUser(Session);

            } catch (e: any) {
              Context.setCancelModalConfig({
                visible: true, title: 'Error', subtitle: e?.message || 'Error', rightBtnText: 'OK',
                onResume: () => Context.setCancelModalConfig({...cancelModalConfig, visible: false})
              });
            }
          }

          if (!val || !curUser || !curUser.userId) {
            Context.logout().then(() => {
              if (Platform.OS === 'web') window.open(LANDING_PAGE_URL, '_self');
            });

          } else console.log('user', curUser);
        }
      })();
    }
  }, []);

  return (
    <>
      {isFullSwing ? (
        <>
          <FSHeader px={20}/>

          <Div h={2} bg="#252526"/>

          <Div gap={5} py={10} px={20}>
            <Div row alignItems="center">
              <Div w={24} alignItems="center"><FontAwesome name="user-circle" size={24} color="#3399FF"/></Div>
              <P fontFamily="DavisSans-Regular" ml={6}>{user?.username}</P>
            </Div>
          </Div>

          <Div h={2} bg="#252526"/>
        </>
      ) : <NewHeader pb={11}/>}

      <ScrollView contentContainerStyle={MainStyle.flex1}>
        <Div row justifyContent="space-between" alignItems={isFullSwing ? 'center' : 'flex-end'}
             mb={isFullSwing ? 4 : 13} h={isFullSwing ? 48 : undefined}>
          <P fontFamily={isFullSwing ? 'DavisSans-Medium' : 'Barlow-Medium'} fs={isFullSwing ? 20 : 30}
             ml={isFullSwing ? 18 : 21} lh={isFullSwing ? undefined : 24}>
            Tournament Series
          </P>
        </Div>

        {isLoading ? (
          <Div flex={1} justifyContent="center" alignItems="center">
            <ActivityIndicator color={colors.white} size="large"/>
          </Div>
        ) : levelsList.length ? (
          <Div mx="auto" w={ITEM_WEIGHT} mb={14} borderColor={activeColor} rounded={4} bg={colors.mainBg}
               borderWidth={1} overflow="hidden">
            <Div h={18} mb={17} bg={activeColor}>
              <P ta="center" fw="700" fs={14} lh={18} tt="uppercase">
                Series
              </P>
            </Div>

            <Btn w={100} h={100} mx="auto" onPress={goTo(levelsList[0].level)} position="relative" mb={6}
                 justifyContent="center" alignItems="center">
              <Image source={star as any} style={{width: 123, height: 123, zIndex: -1, position: 'absolute', top: -13}}/>
              <P fontFamily="DavisSans-Medium">FINAL</P>
              <Div w={4} h={24} position="absolute" bottom={-7} bg="#3BFF2E" zIndex={-2}/>
            </Btn>

            {!!levelsList.slice(1).length && (
              <Div rounded={2} borderWidth={1} mx={7} mb={10} borderColor="#4C4C4C" bg="#252526" maxH={305}>
                <ScrollView contentContainerStyle={[MainStyle.a_i_c, MainStyle.p_b_15]}>
                  {levelsList.slice(1).map(el => (
                    <React.Fragment key={el.level}>
                      <Div w={4} h={10} bg="rgba(59, 255, 46, 0.5)"/>
                      <Btn w={60} h={60} pt={14} onPress={goTo(el.level)} position="relative">
                        <Image source={series_circle as any} style={{width: 90, height: 90, zIndex: -1, position: 'absolute', top: -15, left: -15}}/>
                        <P fontFamily="DavisSans-Medium" fs={14} lh={14} ta="center" tt="uppercase">Level</P>
                        <P fontFamily="DavisSans-Medium" fs={24} lh={24} ta="center">{el.level}</P>
                      </Btn>
                    </React.Fragment>
                  ))}
                </ScrollView>
              </Div>
            )}
          </Div>
        ) : (
          <Div flex={1} justifyContent="center" alignItems="center">
            <P fw="500" fs={32} mb={14} ml={21}>Nothing found</P>
          </Div>
        )}
      </ScrollView>

      <P color={colors.gray} ta="center" fs={17} my={13}>Malfunction voids all pays and plays</P>
    </>
  );
};

export default SatelliteTournaments;
